// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: ':id/allowance-claims',
        component: () =>
            import(/* webpackChunkName: "accounting.asset-allowance-claim" */ '@/pages/[organisation]/accounting/asset-allowance-claim/asset-allowance-claims.vue'),
        name: 'accounting.asset-allowance-claims.search-asset-allowance-claims',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.asset-allowance-claim.view-asset-allowance-claims',
        },
    },
];
